"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.ICON_ONLY_SIZE = void 0;

var _utils = require("../../utils");

var ICON_ONLY_SIZE = Math.max(24, _utils.A11Y_MIN_SIZE);
exports.ICON_ONLY_SIZE = ICON_ONLY_SIZE;
var defaultProps = {
  isExpanded: false,
  hasOutline: false,
  shouldSetAriaExpanded: true
};
exports.defaultProps = defaultProps;